<div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
  @if (hasPermissionToEmploymentConditionsConfirmations() || hasPermissionToMandateAgreementWorkedDayList()) {
    <div
      class="container"
      fxLayout="column"
      fxFlex="100"
      fxLayoutGap="20px"
      >
      <h1 class="header">{{ 'WL-WorkerAgreementList' | translate }}</h1>
      <div class="content-card">
        <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
          <mat-tab [label]="'WL-WorkerAgreement' | translate"> </mat-tab>
          @if (hasPermissionToEmploymentConditionsConfirmations()) {
            <mat-tab
              [label]="'EmploymentConditionsConfirmationList.EmploymentConditionsConfirmationList' | translate"
              >
            </mat-tab>
          }
          @if (hasPermissionToMandateAgreementWorkedDayList()) {
            <mat-tab
              [label]="'MandateAgreementWorkedDayList.MandateAgreementWorkedDayList' | translate"
              >
            </mat-tab>
          }
        </mat-tab-group>
      </div>
      @switch (listType) {
        @case (listTypes.WorkerAgreements) {
          <app-worker-agreements-list></app-worker-agreements-list>
        }
        @case (listTypes.EmploymentConditionsConfirmations) {
          @if (hasPermissionToEmploymentConditionsConfirmations()) {
            <app-employment-conditions-confirmation-list
            ></app-employment-conditions-confirmation-list>
          }
        }
        @case (listTypes.MandateAgreementWorkedDays) {
          @if (hasPermissionToMandateAgreementWorkedDayList()) {
            <app-mandate-agreement-worked-day-list></app-mandate-agreement-worked-day-list>
          }
        }
      }
    </div>
  } @else {
    <div class="container" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
      <h1 class="header">{{ 'WL-WorkerAgreementList' | translate }}</h1>
      <app-worker-agreements-list></app-worker-agreements-list>
    </div>
  }
</div>

